import * as React from 'react';
import { cn } from '@companion-professional/webutils';

// AlertTitle is a title for an alert.
export const AlertTitle = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <h5 ref={ref} className={cn('mb-1 font-semibold leading-tight', className)} {...props} />
  )
);
AlertTitle.displayName = 'AlertTitle';
